import { forwardRef, Fragment } from "react";
import Box from "@mui/material/Box";
import classes from "./PrintContent.module.css";
import Typography from "@mui/material/Typography";
import {
  DateField,
  NumberField,
  RecordContextProvider,
  useTranslate,
  // usePermissions,
} from "react-admin";
import splitArrayToChunks from "../../../utils/splitArrayToChunks";

const PrintContent = forwardRef((props, ref) => {
  // eslint-disable-line max-len
  // const { permissions, isLoading } = usePermissions();
  const t = useTranslate();

  if (props.record.type === 4) {
    return (
      <Box
        component="div"
        sx={{
          display: "none",
        }}
      >
        <Box ref={ref}>
          <style type="text/css" media="print">
            {`@page {
              width: 215.9mm;
              height: 139.7mm;
              size: 8.5in 5.5in portrait;
              margin: 0;
            }
            html, body {
              width: 215.9mm;
              height: 100%;
            }
            .page-break {
              display: block;
              page-break-after: always;
              break-after: page;
              height: 0;
            }
            .page-break:last-child {
              page-break-after: auto;
              break-after: auto;
            }
            .big-back {
              page-break-inside: avoid;
              break-inside: avoid;
            }
          `}
          </style>
          {splitArrayToChunks(
            props.record.mutation_inventory_write_off_items,
            5
          ).map((arr, i, ori) => {
            // TODO semua print content strukturnya perlu ikutin ini
            const totalMutation = arr.reduce(
              (total, item) => total + Number(item.quantity || 0),
              0
            );
            return (
              <Fragment key={i}>
                <Box
                  className="big-back"
                  sx={
                    i > 0
                      ? {
                          position: "relative",
                          overflow: "hidden",
                          mt: 2,
                          fontSize: "12px",
                          py: 2,
                          px: 2,
                          display: "flex",
                          flexDirection: "column",
                          height: "139.7mm",
                          boxSizing: "border-box",
                          fontFamily: "Arial, Helvetica, sans-serif",
                        }
                      : {
                          position: "relative",
                          overflow: "hidden",
                          fontSize: "12px",
                          py: 2,
                          px: 2,
                          display: "flex",
                          flexDirection: "column",
                          height: "139.7mm",
                          boxSizing: "border-box",
                          fontFamily: "Arial, Helvetica, sans-serif",
                        }
                  }
                >
                  <Typography
                    sx={{
                      fontWeight: "bold",
                      mb: 1,
                      fontFamily: "Arial, Helvetica, sans-serif",
                    }}
                  >
                    {props.record.company.name}
                  </Typography>
                  <table className={classes.headerSj}>
                    <thead>
                      <tr>
                        <th style={{ width: "10%" }}>Kepada Yth</th>
                        <th>:</th>
                        <th style={{ width: "60%" }}>
                          {props.record.destination
                            ? props.record.destination
                            : "-"}
                        </th>
                        <th style={{ width: "15%" }}>No. Surat Jalan</th>
                        <th>:</th>
                        <th style={{ width: "15%" }}>{props.record.code}</th>
                      </tr>
                      <tr>
                        <th
                          rowSpan={2}
                          style={{
                            paddingTop: "3px",
                            verticalAlign: "baseline",
                          }}
                        >
                          Alamat
                        </th>
                        <th
                          rowSpan={2}
                          style={{
                            paddingTop: "3px",
                            verticalAlign: "baseline",
                          }}
                        >
                          :
                        </th>
                        <th
                          rowSpan={2}
                          style={{
                            paddingTop: "3px",
                            verticalAlign: "baseline",
                          }}
                        >
                          <span style={{ textTransform: "uppercase" }}>
                            {(props.record.address1
                              ? props.record.address1
                              : "-") +
                              ", " +
                              (props.record.address2
                                ? props.record.address2
                                : "")}
                          </span>
                        </th>
                        <th>Tgl. Pengiriman</th>
                        <th>:</th>
                        <th>
                          <RecordContextProvider value={props.record}>
                            <DateField
                              source="date"
                              sx={{
                                fontWeight: "inherit",
                                fontSize: "12px",
                                fontFamily: "inherit",
                              }}
                              options={{
                                year: "numeric",
                                month: "short",
                                day: "2-digit",
                              }}
                            ></DateField>
                          </RecordContextProvider>
                        </th>
                      </tr>
                      <tr>
                        <th>No. DO</th>
                        <th>:</th>
                        <th>-</th>
                      </tr>
                      <tr>
                        <th>Telp/Fax</th>
                        <th>:</th>
                        <th>{props.record.phone ? props.record.phone : "-"}</th>
                        <th>No. Customer</th>
                        <th>:</th>
                        <th>-</th>
                      </tr>
                    </thead>
                  </table>
                  <Typography
                    sx={{
                      textAlign: "center",
                      fontWeight: "bold",
                      mt: 2,
                      mb: 0.5,
                      fontFamily: "Arial, Helvetica, sans-serif",
                    }}
                  >
                    SURAT JALAN MUTASI ANTAR DEPO
                  </Typography>
                  <table
                    className={`${classes.tableSj} ${classes.mutationTransferTable}`}
                  >
                    <thead>
                      <tr>
                        <th>Kode Barang</th>
                        <th>Nama Barang - Ukuran</th>
                        <th style={{ textAlign: "right" }}>Banyak</th>
                        <th style={{ textAlign: "center" }}>Satuan</th>
                        <th>Keterangan</th>
                      </tr>
                    </thead>
                    <tbody>
                      {arr.map((obj, idx) => {
                        return (
                          <tr key={obj.id} className={classes.mutationTransferItem}>
                            <td>{obj.product.code}</td>
                            <td>{obj.product.name}</td>
                            <td style={{ textAlign: "right" }}>
                              {obj.quantity}
                            </td>
                            <td style={{ textAlign: "center" }}>
                              {obj.product.unit}
                            </td>
                            {idx === 0 && (
                              <td
                                className={classes.mutationTransferNote}
                                rowSpan={arr.length}
                              >
                                {props.record.note}
                              </td>
                            )}
                          </tr>
                        );
                      })}
                      <tr className={classes.mutationTransferTotal}>
                        <td
                          className={classes.mutationTransferTotalLabel}
                          colSpan={2}
                          style={{
                            textAlign: "right",
                            verticalAlign: "baseline",
                            fontWeight: "bold",
                            borderRight: "none",
                          }}
                        >
                          Total:
                        </td>
                        <td
                          className={classes.mutationTransferTotalQuantity}
                          style={{
                            textAlign: "right",
                            verticalAlign: "baseline",
                            fontWeight: "bold",
                            borderLeft: "none",
                          }}
                        >
                          {totalMutation}
                        </td>
                        <td className={classes.mutationTransferTotalNote} colSpan={2}>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              fontSize: "10px",
                            }}
                          >
                            <div>Catatan</div>
                            <div>Lembar ke:</div>
                            <div>
                              <Typography variant="inherit">
                                1. Warna Putih untuk Perusahaan
                              </Typography>
                              <Typography variant="inherit">
                                2. Warna Merah untuk Penerima Barang
                              </Typography>
                              <Typography variant="inherit">
                                3. Warna Kuning untuk Angkutan
                              </Typography>
                              <Typography variant="inherit">
                                4. Warna Biru untuk Gudang
                              </Typography>
                              <Typography variant="inherit">
                                5. Warna Hijau untuk Accounting
                              </Typography>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      mt: "auto",
                      flexShrink: 0,
                    }}
                  >
                    <Box sx={{ textAlign: "center" }}>
                      <Typography variant="inherit" sx={{ mb: 3 }}>
                        Mengetahui
                      </Typography>
                      <Typography>( .............. )</Typography>
                      <Typography variant="inherit">K. DEPO</Typography>
                    </Box>
                    <Box sx={{ textAlign: "center" }}>
                      <Typography variant="inherit" sx={{ mb: 3 }}>
                        Pemeriksa
                      </Typography>
                      <Box
                        sx={{
                          display: "flex",
                          alignItem: "center",
                          justifyContent: "space-evenly",
                        }}
                      >
                        <Box sx={{ mr: 1 }}>
                          <Typography>( .............. )</Typography>
                          <Typography variant="inherit">AKUNTING</Typography>
                        </Box>
                        <Box>
                          <Typography>( .............. )</Typography>
                          <Typography variant="inherit">ADMIN</Typography>
                        </Box>
                      </Box>
                    </Box>
                    <Box sx={{ textAlign: "center" }}>
                      <Typography variant="inherit" sx={{ mb: 3 }}>
                        Pelaksana
                      </Typography>
                      <Box
                        sx={{
                          display: "flex",
                          alignItem: "center",
                          justifyContent: "space-evenly",
                        }}
                      >
                        <Box sx={{ mr: 1 }}>
                          <Typography>( .............. )</Typography>
                          <Typography variant="inherit">K. GUDANG</Typography>
                        </Box>
                        <Box>
                          <Typography>( .............. )</Typography>
                          <Typography variant="inherit">ANGKUTAN</Typography>
                        </Box>
                      </Box>
                    </Box>
                    <Box sx={{ textAlign: "center" }}>
                      <Typography variant="inherit" sx={{ mb: 3 }}>
                        Diterima Oleh
                      </Typography>
                      <Typography>( .............. )</Typography>
                      <Typography variant="inherit">CAP TOKO</Typography>
                    </Box>
                  </Box>
                  <Typography
                    component="p"
                    variant="caption"
                    sx={{
                      textAlign: "right",
                      mt: 0.5,
                      mb: 0,
                      flexShrink: 0,
                      whiteSpace: "nowrap",
                      lineHeight: 1.2,
                      fontSize: "10px",
                      fontFamily: "Arial, Helvetica, sans-serif",
                    }}
                  >
                    Dibuat oleh:{" "}
                    <span style={{ textTransform: "uppercase" }}>
                      {props.record.user.first_name +
                        " " +
                        props.record.user.last_name}
                    </span>{" "}
                    <span>
                      <RecordContextProvider value={props.record}>
                        <DateField
                          showTime
                          source="updated_at"
                          sx={{
                            fontWeight: "inherit",
                            fontSize: "11px",
                            fontFamily: "Arial, Helvetica, sans-serif",
                          }}
                        ></DateField>
                      </RecordContextProvider>
                    </span>
                  </Typography>
                </Box>
                <div className="page-break" />
              </Fragment>
            );
          })}
        </Box>
      </Box>
    );
  } else {
    let checkStatus = "";
    if (props.record.type === 1) {
      checkStatus = t("mine.label.stocktake");
    } else if (props.record.type === 2) {
      checkStatus = t("mine.label.sample");
    }

    var total_sent = { total: 0 };

    return (
      <Box
        component="div"
        sx={{
          display: "none",
        }}
      >
        <Box ref={ref}>
          <style type="text/css" media="print">
            {`@page {
              width: 215.9mm;
              height: 139.7mm;
              size: 8.5in 5.5in portrait;
              margin: 0;
            }
            html, body {
              width: 215.9mm;
              height: 100%;
            }
            .page-break {
              display: block;
              page-break-after: always;
              break-after: page;
              height: 0;
            }
            .page-break:last-child {
              page-break-after: auto;
              break-after: auto;
            }
            .big-back::before {
              content: "";
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              background-image: url('/atena-tiles.png');
              background-repeat: no-repeat;
              background-position: 50% 28%;
              background-size: 20% auto;
              opacity: 0.2;
              z-index: -1;
            }
          `}
          </style>
          {splitArrayToChunks(
            props.record.mutation_inventory_write_off_items,
            5
          ).map((arr, i, ori) => {
            // TODO semua print content strukturnya perlu ikutin ini
            return (
              <Fragment key={i}>
                <Box
                  className="big-back"
                  sx={
                    i > 0
                      ? {
                          position: "relative",
                          overflow: "hidden",
                          mt: 2,
                          fontSize: "12px",
                          py: 2,
                          px: 2,
                          display: "flex",
                          flexDirection: "column",
                          height: "139.7mm",
                          boxSizing: "border-box",
                          fontFamily: "Arial, Helvetica, sans-serif",
                        }
                      : {
                          position: "relative",
                          overflow: "hidden",
                          fontSize: "12px",
                          py: 2,
                          px: 2,
                          display: "flex",
                          flexDirection: "column",
                          height: "139.7mm",
                          boxSizing: "border-box",
                          fontFamily: "Arial, Helvetica, sans-serif",
                        }
                  }
                >
                  <Box
                    sx={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Typography
                      sx={{
                        textTransform: "uppercase",
                        fontFamily: "inherit",
                      }}
                    >
                      {props.record.company.name}
                    </Typography>
                  </Box>
                  <Typography
                    sx={{
                      fontWeight: "bold",
                      mb: 2,
                      textTransform: "uppercase",
                      borderBottom: "1px solid #000",
                      textAlign: "center",
                      fontFamily: "inherit",
                    }}
                  >
                    slip opname kredit barang
                  </Typography>
                  <table className={classes.headerSj}>
                    <thead>
                      <tr>
                        <th style={{ width: "10%", verticalAlign: "top" }}>
                          No. Bukti
                        </th>
                        <th style={{ width: "1px", verticalAlign: "top" }}>
                          :
                        </th>
                        <th style={{ verticalAlign: "top" }}>
                          {props.record.code}
                        </th>
                      </tr>
                      <tr>
                        <th style={{ width: "10%", verticalAlign: "top" }}>
                          Tanggal
                        </th>
                        <th style={{ verticalAlign: "top" }}>:</th>
                        <th style={{ verticalAlign: "top" }}>
                          <RecordContextProvider value={props.record}>
                            <DateField
                              source="date"
                              sx={{
                                fontWeight: "inherit",
                                fontSize: "12px",
                                fontFamily: "inherit",
                              }}
                              options={{
                                year: "numeric",
                                month: "short",
                                day: "2-digit",
                              }}
                            ></DateField>
                          </RecordContextProvider>
                        </th>
                      </tr>
                      <tr>
                        <th style={{ verticalAlign: "top" }}>Tipe</th>
                        <th style={{ verticalAlign: "top" }}>:</th>
                        <th style={{ verticalAlign: "top" }}>{checkStatus}</th>
                      </tr>
                    </thead>
                  </table>
                  <Typography
                    variant="caption"
                    sx={{
                      mt: 1,
                      mb: 1,
                      fontFamily: "inherit",
                    }}
                  >
                    Keterangan: {props.record.note}
                  </Typography>
                  <table className={`${classes.tableSj} ${classes.opnameItems}`}>
                    <thead>
                      <tr>
                        <th>Kode Barang</th>
                        <th>Nama Barang</th>
                        <th style={{ textAlign: "right" }}>Kuantitas</th>
                        <th>Lokasi</th>
                      </tr>
                    </thead>
                    <tbody>
                      {arr.map((obj, idx) => {
                        total_sent.total += +obj.quantity;
                        return (
                          <tr key={obj.id}>
                            <td>{obj.product.code}</td>
                            <td>{obj.product.name}</td>
                            <td style={{ textAlign: "right" }}>
                              <RecordContextProvider value={obj}>
                                <NumberField
                                  source="quantity"
                                  sx={{
                                    fontWeight: "inherit",
                                    fontSize: "12px",
                                    fontFamily: "inherit",
                                  }}
                                ></NumberField>
                              </RecordContextProvider>
                            </td>
                            <td>{obj.warehouse.name}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                    <tfoot>
                      <tr>
                        <td
                          colSpan={2}
                          style={{
                            textAlign: "right",
                            verticalAlign: "baseline",
                            fontWeight: "bold",
                            borderRight: "none",
                          }}
                        >
                          Total:
                        </td>
                        <td style={{ textAlign: "right" }}>
                          <RecordContextProvider value={total_sent}>
                            <NumberField
                              source="total"
                              sx={{
                                fontWeight: "inherit",
                                fontSize: "12px",
                                fontFamily: "inherit",
                              }}
                            ></NumberField>
                          </RecordContextProvider>
                        </td>
                        <td></td>
                      </tr>
                    </tfoot>
                  </table>
                  <table
                    style={{ marginTop: "8px" }}
                    className={`${classes.tableACC} ${classes.opnameSignatures}`}
                  >
                    <thead>
                      <tr>
                        <th colSpan={2}>Mengetahui</th>
                        <th>Pemeriksa</th>
                        <th colSpan={3}>Pelaksana</th>
                      </tr>
                      <tr>
                        <th
                          style={{
                            textTransform: "uppercase",
                            width: "16.66%",
                          }}
                        >
                          M. Keuangan
                        </th>
                        <th
                          style={{
                            textTransform: "uppercase",
                            width: "16.66%",
                          }}
                        >
                          M. Sales
                        </th>
                        <th
                          style={{
                            textTransform: "uppercase",
                            width: "16.66%",
                          }}
                        >
                          Auditor
                        </th>
                        <th
                          style={{
                            textTransform: "uppercase",
                            width: "16.66%",
                          }}
                        >
                          K. Depo
                        </th>
                        <th
                          style={{
                            textTransform: "uppercase",
                            width: "16.66%",
                          }}
                        >
                          Akunting Depo
                        </th>
                        <th
                          style={{
                            textTransform: "uppercase",
                            width: "16.66%",
                          }}
                        >
                          K. Gudang
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td style={{ paddingTop: "60px" }}></td>
                      </tr>
                    </tbody>
                  </table>
                </Box>
                <div className="page-break" />
              </Fragment>
            );
          })}
        </Box>
      </Box>
    );
  }
});
export default PrintContent;
